import { all, call } from 'redux-saga/effects';

import watchMomentumSaga from './momentum';

export function* momentumSaga() {
	yield all([
		call(watchMomentumSaga),
	]);
}
